import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useConvertBase64} from "../hooks/useConvertBase64";
import {Button, Grid, IconButton, TextField, Typography} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

type InputFileType = {
  file: string;
  fileName: string;
  buttonLabel?: string;
};

const MWInputFile = ({file, fileName, buttonLabel}: InputFileType) => {
  const {convertChangeHandler, image} = useConvertBase64();

  const methods = useFormContext();

  const {setValue, getValues, control, watch} = methods;

  return (
    <Controller
      name={file}
      control={control}
      render={({field: {onChange, name, value}, fieldState: {error}}) => (
        <>
          <Grid container alignItems="center" flexWrap="nowrap" width="100%" pt="8px" pb="4px">
            <Button
              variant="outlined"
              component="label"
              size="small"
              sx={{whiteSpace: "nowrap", flexShrink: 0}}
            >
              {buttonLabel || "파일 선택"}
              <TextField
                sx={{display: "none"}}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  convertChangeHandler(event, setValue, name, fileName)
                }
                type="file"
                id={file}
                size="small"
                hidden
              />
            </Button>
            <Typography variant="subtitle2" sx={{marginLeft: "8px", lineHeight: 1}}>
              {watch(fileName)}
              {watch(fileName) && (
                <IconButton
                  aria-label="delete"
                  color="secondary"
                  onClick={() => {
                    setValue(file, "");
                    setValue(fileName, "");
                  }}
                >
                  <HighlightOffIcon />
                </IconButton>
              )}
            </Typography>
          </Grid>
          <Typography
            sx={{fontSize: "12px", color: "red", alignSelf: "flex-start", paddingLeft: "16px"}}
          >
            {error?.message}
          </Typography>
        </>
      )}
    />
  );
};

export default MWInputFile;
